import { Button, Message, useToaster } from 'rsuite';
import React from 'react';

import * as trainersApi from '../../api/trainers';
import { FormModal } from '../../common/FormModal';
import { useFormErrors } from '../../common/useFormErrors';
import TrainerModalContent from './TrainerModalContent';

type Props = {
  open: boolean;
  setOpen: (newValue: boolean) => void;
  callback: () => void;
};

export default function CreateTrainerModal({ open, setOpen, callback }: Props) {
  const toaster = useToaster();
  const { errorSummary, setApiError, clearErrors } = useFormErrors({
    fallbackMessage: 'Не вдалося створити тренера. Спробуйте пізніше',
    resetOn: [open],
  });
  const [modalTrainerTitle, setModalTrainerTitle] = React.useState<string>('');
  const [modalTrainerTitleEn, setModalTrainerTitleEn] =
    React.useState<string>('');
  const [modalTrainerTitleDe, setModalTrainerTitleDe] =
    React.useState<string>('');
  const [modalTrainerSlug, setModalTrainerSlug] = React.useState<string>('');
  const [modalTrainerName, setModalTrainerName] = React.useState<string>('');
  const [modalTrainerNameEn, setModalTrainerNameEn] =
    React.useState<string>('');
  const [modalTrainerNameDe, setModalTrainerNameDe] =
    React.useState<string>('');
  const [modalTrainerDescription, setModalTrainerDescription] =
    React.useState<string>('');
  const [modalTrainerDescriptionEn, setModalTrainerDescriptionEn] =
    React.useState<string>('');
  const [modalTrainerDescriptionDe, setModalTrainerDescriptionDe] =
    React.useState<string>('');
  const [modalTrainerShortDescription, setModalTrainerShortDescription] =
    React.useState<string>('');
  const [modalTrainerShortDescriptionEn, setModalTrainerShortDescriptionEn] =
    React.useState<string>('');
  const [modalTrainerShortDescriptionDe, setModalTrainerShortDescriptionDe] =
    React.useState<string>('');
  const [modalTrainerPriority, setModalTrainerPriority] =
    React.useState<number>(0);
  const [modalTrainerActive, setModalTrainerActive] =
    React.useState<boolean>(false);
  const [modalTrainerFeatured, setModalTrainerFeatured] =
    React.useState<boolean>(false);

  return (
    <FormModal
      open={open}
      onClose={() => setOpen(false)}
      title="Створити тренера"
      errorSummary={errorSummary}
      footer={
        <>
          <Button
            onClick={async () => {
              clearErrors();
              try {
                await trainersApi.create(
                  modalTrainerSlug,
                  modalTrainerTitle,
                  modalTrainerTitleEn,
                  modalTrainerTitleDe,
                  modalTrainerName,
                  modalTrainerNameEn,
                  modalTrainerNameDe,
                  modalTrainerDescription,
                  modalTrainerDescriptionEn,
                  modalTrainerDescriptionDe,
                  modalTrainerShortDescription,
                  modalTrainerShortDescriptionEn,
                  modalTrainerShortDescriptionDe,
                  modalTrainerPriority,
                  modalTrainerActive,
                  modalTrainerFeatured
                );
                toaster.push(
                  <Message type="success" showIcon closable>
                    Тренера створено
                  </Message>,
                  {
                    placement: 'topEnd',
                    duration: 1500,
                  }
                );
                setOpen(false);
                setModalTrainerTitle('');
                setModalTrainerTitleEn('');
                setModalTrainerTitleDe('');
                setModalTrainerSlug('');
                setModalTrainerName('');
                setModalTrainerNameEn('');
                setModalTrainerNameDe('');
                setModalTrainerDescription('');
                setModalTrainerDescriptionEn('');
                setModalTrainerDescriptionDe('');
                setModalTrainerShortDescription('');
                setModalTrainerShortDescriptionEn('');
                setModalTrainerShortDescriptionDe('');
                setModalTrainerPriority(0);
                setModalTrainerActive(false);
                setModalTrainerFeatured(false);
                callback();
              } catch (err: any) {
                console.error(err);
                const errorMessage = setApiError(err)[0];
                toaster.push(
                  <Message type="error" showIcon closable>
                    {errorMessage}
                  </Message>,
                  {
                    placement: 'topEnd',
                    duration: 1500,
                  }
                );
              }
            }}
            appearance="primary"
          >
            Створити
          </Button>
          <Button onClick={() => setOpen(false)} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <TrainerModalContent
        modalTrainerTitle={modalTrainerTitle}
        modalTrainerTitleEn={modalTrainerTitleEn}
        modalTrainerTitleDe={modalTrainerTitleDe}
        modalTrainerSlug={modalTrainerSlug}
        modalTrainerName={modalTrainerName}
        modalTrainerNameEn={modalTrainerNameEn}
        modalTrainerNameDe={modalTrainerNameDe}
        modalTrainerDescription={modalTrainerDescription}
        modalTrainerDescriptionEn={modalTrainerDescriptionEn}
        modalTrainerDescriptionDe={modalTrainerDescriptionDe}
        modalTrainerShortDescription={modalTrainerShortDescription}
        modalTrainerShortDescriptionEn={modalTrainerShortDescriptionEn}
        modalTrainerShortDescriptionDe={modalTrainerShortDescriptionDe}
        modalTrainerPriority={modalTrainerPriority}
        modalTrainerActive={modalTrainerActive}
        modalTrainerFeatured={modalTrainerFeatured}
        setModalTrainerTitle={setModalTrainerTitle}
        setModalTrainerTitleEn={setModalTrainerTitleEn}
        setModalTrainerTitleDe={setModalTrainerTitleDe}
        setModalTrainerSlug={setModalTrainerSlug}
        setModalTrainerName={setModalTrainerName}
        setModalTrainerNameEn={setModalTrainerNameEn}
        setModalTrainerNameDe={setModalTrainerNameDe}
        setModalTrainerDescription={setModalTrainerDescription}
        setModalTrainerDescriptionEn={setModalTrainerDescriptionEn}
        setModalTrainerDescriptionDe={setModalTrainerDescriptionDe}
        setModalTrainerShortDescription={setModalTrainerShortDescription}
        setModalTrainerShortDescriptionEn={setModalTrainerShortDescriptionEn}
        setModalTrainerShortDescriptionDe={setModalTrainerShortDescriptionDe}
        setModalTrainerPriority={setModalTrainerPriority}
        setModalTrainerActive={setModalTrainerActive}
        setModalTrainerFeatured={setModalTrainerFeatured}
      />
    </FormModal>
  );
}
